/**
 * This operation splits a given path into a folder and a filename section.
 *
 * Some notes:
 *  - The path separator can be '/' or '\'.
 *  - If a path is a url, any url parameters will be stripped.
 *
 * @param {string} path The path to split.
 * @returns An object containing a filename and a folder.
 */
export function splitPath(path) {
  return split(sanitize(path));
}

function sanitize(path) {
  let sanitizedPath = path;

  // For urls, remove url params.
  if (sanitizedPath.includes('?')) {
    sanitizedPath = sanitizedPath.split('?')[0];
  }

  return sanitizedPath;
}

function split(path) {
  let lastSlashIndex = path.lastIndexOf('\\');
  if (lastSlashIndex === -1) {
    lastSlashIndex = path.lastIndexOf('/');
  }

  return {
    folder:   path.substring(0, lastSlashIndex),
    filename: path.substring(lastSlashIndex + 1),
  };
}
